import { useState, useEffect, useRef } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import axios from "axios";
import { UrlApi } from '../../UrlApi/UrlApi';
import { AlertWarning, AlertError, AlertSuccess } from '../../Components/AlertDialog/AlertDialog';
import Loading from '../../Components/Loading/Loading';
import { TextInput } from '../../Components/Input/Input';
import { useParams } from "react-router-dom";
import { InputAdornment, IconButton } from '@mui/material';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ReCAPTCHA from "react-google-recaptcha";
import { sitekey } from "../../UrlApi/UrlApi";
import { path } from '../../UrlApi/UrlApi';
import Logo from '../../Assets/Images/logo.jpg';


const theme = createTheme();
export default function ResetPassword() {
  const [loading, setLoading] = useState(false);
  const [passwordErr, setPasswordErr] = useState(false);
  const [passwordCofirmErr, setPasswordCofirmErr] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [verify, setVerify] = useState(false);
  const captchaRef = useRef(null);

  const [password, setPassword] = useState("");
  const [passwordCofirm, setPasswordCofirm] = useState("");

  const { token } = useParams();

  const onSubmit = async (event) => {
    event.preventDefault();
    const tokenVerify = "";
    // captchaRef.current.reset();
    // setVerify(true);
    const authorization = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    if (!isValidPassword(password)) { setPasswordErr(true); return false; } else { setPasswordErr(false) }
    if (password !== passwordCofirm) { setPasswordCofirmErr(true); return false; } else { setPasswordCofirmErr(false); }
    setLoading(true);
    await axios.post(UrlApi + 'reset_password', { password, token: tokenVerify }, authorization).then((res) => {
      if (res.data.status === 1) {
        setLoading(false);
        AlertSuccess(res.data.message, () => {
          window.location = path + '/login';
        });
      } else {
        AlertSuccess(res.data.message, () => {
        });
        setLoading(false);
        AlertError(res.data.message);
      }
    }).catch((err) => {
      setLoading(false);
      AlertError(err);
    });
  };

  function isValidPassword(passWord) {
    const lower = new RegExp(/(?=.*[a-z])/);
    const upper = new RegExp(/(?=.*[A-Z])/);
    const number = new RegExp(/(?=.*[0-9])/);
    const special = new RegExp(/(?=.*[-_?!@#\$%/^&\*])/);
    const length = new RegExp(/(?=.{12,})/);
    const checkPassword = [lower.test(passWord), upper.test(passWord), number.test(passWord), special.test(passWord), length.test(passWord)];
    return checkPassword.every(element => element === true);
  }

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${Logo})`,
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              รีเซ็ตรหัสผ่าน
            </Typography>
            <Box component="form" noValidate onSubmit={onSubmit} sx={{ mt: 1 }}>
              <TextInput
                value={password}
                type={showPassword ? "text" : "password"}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (isValidPassword(e.target.value)) {
                    setPasswordErr(false);
                  }
                }}
                error={passwordErr}
                helperText={<label style={{ fontSize: '12px' }}>รหัสผ่านต้องประกอบด้วยตัวอักษรพิมพ์เล็ก (a-z) พิมพ์ใหญ่ (A-Z) <br />
                  ตัวเลข (0-9) อักขระพิเศษ เช่น (-_?!@#\$%/^&\*) และมีความยาวอย่างน้อย 12 ตัวอักษร
                </label>
                }
                onKeyDown={() => { }}
                width="100%"
                height={50}
                placeholder="กรอก รหัสผ่าน"
                endAdornment={((
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </InputAdornment>
                ))}
              />
              <TextInput
                value={passwordCofirm}
                type={showPasswordConfirm ? "text" : "password"}
                onChange={(e) => {
                  setPasswordCofirm(e.target.value);
                  if (e.target.value === password) {
                    setPasswordCofirmErr(false);
                  }
                }}
                error={passwordCofirmErr}
                helperText={passwordCofirmErr && "รหัสผ่านไม่ตรงกัน"}
                onKeyDown={() => { }}
                width="100%"
                height={50}
                placeholder="ยืนยัน รหัสผ่าน"
                endAdornment={((
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                      edge="end"
                    >
                      {showPasswordConfirm ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </InputAdornment>
                ))}
              />
              <Button
                disabled={verify}
                type="submit"
                fullWidth
                variant="contained"
                sx={{ m: 1, mt: 3, mb: 2, background: '#1676FC' }}
              >
                ยืนยัน
              </Button>
              {/* <ReCAPTCHA
                sitekey={sitekey}
                onChange={(value) => {
                  setVerify(false);
                }}
                ref={captchaRef}
                style={{ marginLeft: '10px' }}
              /> */}
            </Box>
          </Box>
        </Grid>
      </Grid>
      {<Loading open={loading} />}
    </ThemeProvider>
  );
}